module.exports = __webpack_public_path__ + "static/media/item_19_3_comp.415719ea.png";